import { getDegreesAndDecimalMinutesFromLatLng,
    getLatLngFromDegreesAndDecimalMinutes,
    getWGS84LatLngFromLatLng,
    getDecimalDegreesFromLatLng,
    getLatLngFromDecimalDegrees,
    getNationalGridReferenceFromLatLng,
    getLatLngFromEastingsNorthings,
    getGPSLatLngFromLatLng,
    getLatLngFromGPSLatLng,
    getELRsWithin1000MetresFromLatLng,
    getLatLngFromELR,
    getPostcodeAddressFromLatLng,
    getLatLngFromPostcode,
    getAllFormatsFromLatLng } from './converter';

const locationUtils = {
  LatLngToDDM: getDegreesAndDecimalMinutesFromLatLng,
  DDMToLatLng: getLatLngFromDegreesAndDecimalMinutes,
  LatLngToWGS84LatLng: getWGS84LatLngFromLatLng,
  LatLngToDecimalDegrees: getDecimalDegreesFromLatLng,
  DecimalDegressToLatLng: getLatLngFromDecimalDegrees,
  LatLngToNGR: getNationalGridReferenceFromLatLng,
  EastNorthToLatLng: getLatLngFromEastingsNorthings,
  LatLngToGPSLatLng: getGPSLatLngFromLatLng,
  GPSLatLngToLatLng: getLatLngFromGPSLatLng,
  NearbyELRsToLatLng: getELRsWithin1000MetresFromLatLng,
  ELRToLatLng: getLatLngFromELR,
  LatLngToPostcode: getPostcodeAddressFromLatLng,
  PostcodeToLatLng: getLatLngFromPostcode,
  getAllFromLatLng: getAllFormatsFromLatLng
}

export default locationUtils